import React, { useEffect, useRef, useState } from 'react';
import { LANGUAGES } from '../../constants/globalConstants';
import './LanguageSelector.css';

interface LanguageSelectorProps {
  language: string;
  changeLanguage: (lang: string) => void;
}

const languageOptions = [
  { code: LANGUAGES.Serbian, shortLabel: 'SR', label: 'Srpski' },
  { code: LANGUAGES.English, shortLabel: 'GB', label: 'English' },
  { code: LANGUAGES.Slovenian, shortLabel: 'SI', label: 'Slovenscina' },
];

const LanguageSelector = ({
  language,
  changeLanguage,
}: LanguageSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const currentLanguage =
    languageOptions.find((option) => option.code === language) ||
    languageOptions[0];

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <div className="language-toggle" ref={containerRef}>
      <button
        type="button"
        className="language-toggle-button"
        onClick={() => setIsOpen((open) => !open)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span>{currentLanguage.shortLabel}</span>
        <svg
          className={`language-toggle-chevron ${isOpen ? 'open' : ''}`}
          fill="none"
          viewBox="0 0 12 12"
          aria-hidden="true"
        >
          <path
            d="M3 5l3 3 3-3"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="language-menu" role="listbox">
          {languageOptions.map((option) => (
            <button
              key={option.code}
              type="button"
              className={`language-menu-option ${
                option.code === language ? 'active' : ''
              }`}
              onClick={() => {
                changeLanguage(option.code);
                setIsOpen(false);
              }}
            >
              <span className="language-menu-short">{option.shortLabel}</span>
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
